// WHY: drives the "enable advanced edit" banner — detects whether a drafts search
// filter targets any column not shown in the basic table view, recursing through the
// predicate tree (or/not) and comparing leaf fields against the basic-column allowlist.
const BASIC_COLUMN_FIELDS = new Set([
    'clientName',
    'agreementName',
    'lastModifiedBy',
    'lastUpdatedAt'
]);
const RECURSIVE_FIELDS = new Set([
    'or',
    'not'
]);
const predicateTargetsHiddenColumn = (predicate)=>{
    var _predicate_or;
    if ((_predicate_or = predicate.or) === null || _predicate_or === void 0 ? void 0 : _predicate_or.some(predicateTargetsHiddenColumn)) {
        return true;
    }
    if (predicate.not != null && predicateTargetsHiddenColumn(predicate.not)) {
        return true;
    }
    return Object.entries(predicate).some((param)=>{
        let [key, value] = param;
        if (key === 'version' || RECURSIVE_FIELDS.has(key) || value == null || Array.isArray(value) && value.length === 0) {
            return false;
        }
        return !BASIC_COLUMN_FIELDS.has(key);
    });
};
export const hasHiddenColumnFilter = (filter)=>filter != null && predicateTargetsHiddenColumn(filter);
